import { login, getStuUserInfo, logout, loginCode } from '@/api'
import { getToken, setToken, setGuid, removeToken, getGuid, getCode, setCode, getUserInfo, setUserInfo } from '@/utils/auth'
import { resetRouter } from '@/router'


const state = { // 设置状态
  token: getToken(),
  guid: getGuid(), // 用户guid
  name: null,
  avatar: null,
  roles: [],
  selectedRole: {},
  menu: null,
  code: getCode(),
  dutiesName: null,
  action: [],
  loginType: false,
  loading:false,
  userInfo:getUserInfo(),
}







const mutations = { // 同步计算
  SET_LoginType: (state, v) => {
      state.loginType = v;
  },

  SET_TOKEN: (state, token) => {
    // 令牌
    state.token = token
  },
  SET_NAME: (state, name) => {
    // 用户名
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    // 权限
    state.avatar = avatar
  },
  set_guid: (state, guid) => {
    // 用户guid
    state.guid = guid
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  // 侧边栏 菜单
  SET_MENU: (state, menu) => {
    state.menu = menu
  },
  // 操作动作
  SET_ACTION: (state, action) => {
    state.action = action
  },
  // 设置code
  SET_CODE: (state, code) => {
    state.code = code
  },
  SET_DUTIES: (state, dutiesName) => {
    // 职务名称
    state.dutiesName = dutiesName
  },
  SET_SELECTED_ROLE: (state, selectedRole) => {
    // 职务名称
    state.selectedRole = selectedRole
  },
  SET_LOADING: (state, v) => {
        state.loading = v;
  },
  SET_USERINFO: (state, v) => {
    state.userInfo = v;
  },
}

function getStuUserInfoFun ()
{
  getStuUserInfo( { guid: state.guid })
    .then(response => {

      //记录个人信息
      state.userInfo = response
      
      setUserInfo(response)
      var userinfo = getUserInfo()

    })
    .catch(error => {
      reject(error)
    })
 
}



const actions = {
  setLoading: ({commit}, v) => {
        commit('SET_LOADING', v);
  },
  setLoginType: ({commit}, v) => {
      commit('SET_LoginType', v);
  },
  setUserInfoData: ({commit}, v) => {
      commit('SET_USERINFO', v);
      setUserInfo(v)
  },
  // user login
  login({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      login(userInfo)
        .then(response => {

          commit('SET_LoginType', false)

          commit('SET_TOKEN', response.crested_ibis_token)
          commit('SET_CODE', response.code)
          commit('set_guid', response.guid)
          setGuid(response.guid)
          setToken(response.crested_ibis_token)
          setCode(response.code)
          getStuUserInfoFun()

          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  loginCode({ commit }, userInfo) {
    return new Promise((resolve, reject) => {
      loginCode(userInfo)
        .then(response => {
          resolve()
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getStuUserInfoFun()
        
    })
  },

  // user logout
  logout({ commit, state }) {
    return new Promise((resolve, reject) => {
      // getStuUserInfoFun()
          //移除所有登录信息
          removeToken()
          
          commit('set_guid', '')
          commit('SET_TOKEN', '')
          commit('SET_DUTIES', '')
          commit('SET_NAME', null)
          // 菜单栏选项
          commit('SET_MENU', null)
          // 用户所拥有的操作动作
          commit('SET_ACTION', [])
          // 用户所拥有的角色
          commit('SET_ROLES', [])

          resetRouter()
          resolve()

    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      removeToken()
      resolve()
    })
  }
}

export default {
  namespaced: true, // 开启命名空间防止变量重复
  state,
  mutations,
  actions
}
